import { GetServerSideProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import dynamic from "next/dynamic";
import Head from "next/head";
import { ReactElement } from "react";

import { myFollowingTranslations } from "@/consts/pageTranslationNamespace";
import { TableTitle } from "@/features/common/components/Table/Layout";
import { Loading } from "@/features/common/components/informationContainer";
import { Container } from "@/features/common/components/layout/Container";
import SiteLayout from "@/features/common/components/navigation/SiteLayout";
import { SettingMenuView } from "@/features/section/components/setting/SettingMenuView";
import { LoginRequired } from "@/features/user/components";
import { useUserContext } from "@/features/user/contexts/useUserContext";
import { getPublicConfig } from "@/helpers/getPublicConfig";

const FollowingUserList = dynamic(
  () =>
    import("@/features/follow/components/following/FollowingUserList").then(
      (mod) => mod.FollowingUserList,
    ),
  { ssr: false },
);

function MyFollowing() {
  const config = getPublicConfig();
  const { user, ready } = useUserContext();
  const { t } = useTranslation(["following", "common"]);

  if (!ready) return <Loading />;
  if (ready && !user) return <LoginRequired />;

  return (
    <>
      <Head>
        <title>{`${t("common:pageNavigation.myFollowing")} | ${
          config.siteName
        }`}</title>
      </Head>

      <Container maxWidth="lg">
        <SettingMenuView>
          <TableTitle>{t(`common:pageNavigation.myFollowing`)}</TableTitle>

          <FollowingUserList />
        </SettingMenuView>
      </Container>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, myFollowingTranslations)),
    },
  };
};

MyFollowing.getLayout = function getLayout(page: ReactElement) {
  return <SiteLayout showFooter>{page}</SiteLayout>;
};

export default MyFollowing;
